import axios from "axiosConfig";
import {
  saveUserToStorage,
  getUserFromStorage,
  removeUserFromStorage,
  saveIsVerifiedToStorage,
  getIsVerifiedFromStorage,
} from "services/storage-utils";

const register = (username, email, password) => {
  return axios.post("api/auth/register/", {
    username,
    email,
    password,
  });
};

const login = (username, password, rememberMe) => {
  return axios
    .post("api/auth/login/", {
      username,
      password,
    })
    .then(response => {
      if (response.data.token) {
        saveUserToStorage(response.data, rememberMe);
      }

      return response.data;
    });
};

const checkEmailStatus = () => {
  return axios.get("api/auth/email-status/").then(response => {
    const is_verified = response.data && response.data.is_verified;
    if (is_verified) {
      saveIsVerifiedToStorage(response.data);
    }

    return response.data;
  });
};
const verifyEmail = token => {
  return axios.post(`api/auth/email-verify/${token}/`).then(response => {
    console.log({ response });

    const is_verified = response.data && response.data.is_verified;
    if (is_verified) {
      saveIsVerifiedToStorage(response.data);
    }

    return response.data;
  });
};

const updateProfile = () => {
  return axios.get("api/auth/profile/").then(response => {
    const userInStorage = getUserFromStorage();
    const userProfile = response.data;
    userInStorage.user = userProfile;
    saveUserToStorage(userInStorage);
    return response.data;
  });
};

const isVerified = () => {
  return getIsVerifiedFromStorage();
};

const logout = () => {
  removeUserFromStorage();
};

const AuthService = {
  register,
  login,
  isVerified,
  checkEmailStatus,
  verifyEmail,
  logout,
  updateProfile,
};
export default AuthService;
